import { render, staticRenderFns } from "./sci.vue?vue&type=template&id=a0f82d9e&scoped=true"
import script from "./sci.vue?vue&type=script&lang=js"
export * from "./sci.vue?vue&type=script&lang=js"
import style0 from "./sci.vue?vue&type=style&index=0&id=a0f82d9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f82d9e",
  null
  
)

export default component.exports